export const compareTemplateGroups = (a: WorkflowTemplateGroup, b: WorkflowTemplateGroup): number => {
  return a.group_name.localeCompare(b.group_name);
};

export const compareGroups = (a: Group, b: Group): number => {
  return a.name.localeCompare(b.name);
};
